var toString = require('../lang/toString');
var camelCase = require('./camelCase');
var upperCase = require('./upperCase');
    /**
     * camelCase + UPPERCASE first char
     */
    function pascalCase(str){
        str = toString(str);
        return camelCase(str).replace(/^[a-z]/, upperCase);
    }

    module.exports = pascalCase;




/*****************
 ** WEBPACK FOOTER
 ** ./~/mout/string/pascalCase.js
 ** module id = 14
 ** module chunks = 0
 **/